<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          v-show="showPriceNo"
          ref="keyword"
          v-model="filter.priceNo"
          no="priceNo"
          style="width:200px;"
          :placeholder="simQueryPlaceholder"
          :spellcheck="false"
          @blur="keyWordBlur"
          @keyup.enter.native.prevent="toQuery"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPol"
          no="simPol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPol"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPol=p.value}"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPod"
          no="simPod"
          filterable
          :placeholder="$t('Pricing.PODPrompt')"
          :select-type="selectTypeNames.basic_data_Seaport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPod"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPod=p.value}"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && showCurrency"
          no="currency"
          style="width: 115px;display: inline-block;"
          filterable
          :disabled="disabled"
          :clearable="false"
          :default-value="filter.currency"
          :select-type="selectTypeNames.basic_data_Currency"
          @parentCallBack="p=>{filter.currency=p.value}"
        />
        <el-select
          v-if="!isShowingMoreSearchCondition && showLevel"
          v-model="filter.level"
          no="level"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @change="onLevelChanged"
        >
          <el-option
            v-for="(item,index) in tiers"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div ref="searchOperations" class="cargo-advance-search-operations">
        <el-button no="toQuery" style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button no="resetSearch" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations">
        <div>
          <el-form ref="hbDetail" label-width="80px" label-position="left" :inline="true">
            <el-radio-group v-model="rdoGroupOrg" no="rdoGroupOrg">
              <el-radio no="pol" label="pol">{{ $t('Pricing.POL') }}</el-radio>
              <el-radio no="pols" label="pols">{{ $t('Pricing.POLs') }}</el-radio>
              <el-radio no="col" label="col">{{ $t('Pricing.COL') }}</el-radio>
              <el-radio no="rol" label="rol">{{ $t('Pricing.ROL') }}</el-radio>
            </el-radio-group>
            <cargo-advance-select
              v-if="rdoGroupOrg === 'pol'"
              no="pol"
              filterable
              :placeholder="$t('Pricing.POLPrompt')"
              :select-type="selectTypeNames.basic_data_Seaport"
              :custom-label="(item)=>`[${item.code}]${item.englishName}`"
              :filter-tag-names="['code','englishName']"
              :show-custom-label-in-option="true"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :default-value="filter.pol"
              @parentCallBack="p=>{filter.pol=p.value}"
            />
            <cargo-pop-select-input
              v-if="rdoGroupOrg === 'pols'"
              v-model="filter.pols"
              no="pols"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :column-defs="popSelectInputCols"
              :use-type="2"
            />
            <cargo-advance-select
              v-if="rdoGroupOrg === 'col'"
              no="col"
              filterable
              :placeholder="$t('Pricing.COLPrompt')"
              :select-type="selectTypeNames.basic_data_Country"
              :default-value="filter.col"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.col=p.value}"
            />
            <cargo-advance-select
              v-if="rdoGroupOrg === 'rol'"
              no="rol"
              filterable
              :select-type="selectTypeNames.basic_data_Region"
              :default-value="filter.rol"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.rol=p.value}"
            />
            <el-select
              v-show="isManageModule || isShowCreatedBy"
              v-model="filter.cmbCreatedBy"
              no="cmbCreatedBy"
              :disabled="isShowCreatedBy"
              style="width:100px;display: inline-block;margin-left: 10px;"
            >
              <el-option no="createdBy" :label="$t('Pricing.CreatedBy')" value="createdBy" />
              <el-option no="branch" :label="$t('Pricing.Branch')" value="branch" />
            </el-select>
            <cargo-advance-select
              v-if="filter.cmbCreatedBy === 'createdBy' && (isManageModule || isShowCreatedBy)"
              no="createdBy"
              filterable
              :select-type="selectTypeNames.basic_data_User"
              :default-value="filter.createdBy"
              :callback-params="{key:'userId'}"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.createdBy=p.value}"
            />
            <cargo-office-select
              v-if="filter.cmbCreatedBy === 'branch' && (isManageModule || isShowCreatedBy)"
              no="branch"
              :disabled="false"
              :office-id="filter.branch"
              :default-value="filter.branch"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.branch=p.value}"
            />
            <el-form-item v-if="isManageModule" :label="$t('Pricing.CreatedDate')" style="margin-left: 10px;">
              <el-date-picker
                v-model="filter.createDateFrom"
                no="createDateFrom"
                type="date"
                style="width:130px;margin-left:10px"
                :picker-options="{
                  disabledDate: time => {
                    return (
                      time.getTime() >
                      new Date(filter.createDateTo + ' 23:59:59').getTime()
                    )
                  }
                }"
                value-format="yyyy-MM-dd"
              />
              <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
              <el-date-picker
                v-model="filter.createDateTo"
                no="createDateTo"
                type="date"
                style="width:130px;margin-left:10px"
                :picker-options="{
                  disabledDate: time => {
                    return (
                      time.getTime() <
                      new Date(filter.createDateFrom + ' 00:00:00').getTime()
                    )
                  }
                }"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item v-show="showCurrency" ref="hbCurrency" :label="$t('Pricing.Currency')" style="margin-left: 10px;">
              <cargo-advance-select
                v-model="filter.currency"
                no="currency"
                style="width: 115px;"
                filterable
                :disabled="disabled"
                :clearable="false"
                :default-value="filter.currency"
                :select-type="selectTypeNames.basic_data_Currency"
                @parentCallBack="p=>{filter.currency=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form ref="hbDetail2" label-width="80px" label-position="left" :inline="true">
            <el-radio-group v-model="rdoGroupDes" no="rdoGroupDes">
              <el-radio no="pod" label="pod">{{ $t('Pricing.POD') }}</el-radio>
              <el-radio no="pods" label="pods">{{ $t('Pricing.PODs') }}</el-radio>
              <el-radio no="cod" label="cod">{{ $t('Pricing.COD') }}</el-radio>
              <el-radio no="rod" label="rod">{{ $t('Pricing.ROD') }}</el-radio>
            </el-radio-group>
            <cargo-advance-select
              v-if="rdoGroupDes === 'pod'"
              no="pod"
              filterable
              :placeholder="$t('Pricing.POLPrompt')"
              :select-type="selectTypeNames.basic_data_Seaport"
              :custom-label="(item)=>`[${item.code}]${item.englishName}`"
              :filter-tag-names="['code','englishName']"
              :show-custom-label-in-option="true"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :default-value="filter.pod"
              @parentCallBack="p=>{filter.pod=p.value}"
            />
            <cargo-pop-select-input
              v-if="rdoGroupDes === 'pods'"
              v-model="filter.pods"
              no="pods"
              style="width:190px;display: inline-block;margin-left: 10px;"
              :column-defs="popSelectInputCols"
              :use-type="2"
            />
            <cargo-advance-select
              v-if="rdoGroupDes === 'cod'"
              no="cod"
              filterable
              :placeholder="$t('Pricing.COLPrompt')"
              :select-type="selectTypeNames.basic_data_Country"
              :default-value="filter.cod"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.cod=p.value}"
            />
            <cargo-advance-select
              v-if="rdoGroupDes === 'rod'"
              no="rod"
              filterable
              :select-type="selectTypeNames.basic_data_Region"
              :default-value="filter.rod"
              style="width:190px;display: inline-block;margin-left: 10px;"
              @parentCallBack="p=>{filter.rod=p.value}"
            />
            <el-form-item ref="hbCarrier" :label="$t('Pricing.Carrier')" style="margin-left: 10px;">
              <cargo-advance-select
                no="carrier"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                :show-custom-label-in-option="true"
                tag-value="scac"
                style="width:300px;"
                :multiple="true"
                :default-multiple-value="filter.carrier"
                @parentCallBack="p=>{filter.carrier=p.scac}"
              />
            </el-form-item>
            <el-form-item ref="hbSource" :label="$t('Pricing.Source')" style="margin-left: 10px;">
              <el-input v-model="filter.txtBookingAgent" no="txtBookingAgent" style="width: 100px;" />
            </el-form-item>
            <el-form-item :label="$t('Pricing.BeginDate')" style="margin-left: 10px;">
              <el-date-picker
                v-model="filter.beginDate"
                no="beginDate"
                type="date"
                style="width:130px;margin-left:10px"
                :picker-options="{
                  disabledDate: time => {
                    return (
                      time.getTime() >
                      new Date(filter.endDate + ' 23:59:59').getTime()
                    )
                  }
                }"
                value-format="yyyy-MM-dd"
              />
              <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
              <el-date-picker
                v-model="filter.endDate"
                no="endDate"
                type="date"
                style="width:130px;margin-left:10px"
                :picker-options="{
                  disabledDate: time => {
                    return (
                      time.getTime() <
                      new Date(filter.beginDate + ' 00:00:00').getTime()
                    )
                  }
                }"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item ref="hbContractNo" :label="$t('Pricing.ContractNo')" style="margin-left: 10px;">
              <el-input v-model="filter.contractNo" no="contractNo" style="width: 100px;" />
            </el-form-item>
            <el-form-item v-show="showLevel" ref="hbLevel" :label="$t('Pricing.Level')" style="margin-left: 10px;">
              <el-select
                v-model="filter.level"
                no="level"
                style="width:190px;display: inline-block;margin-left: 10px;"
                @change="onLevelChanged"
              >
                <el-option
                  v-for="(item,index) in tiers"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form v-show="showSchedule" ref="hbDetail3" style="line-height: 25px" label-width="80px" label-position="left" :inline="true">
            <el-checkbox v-model="filter.direct" no="direct">{{ $t('Pricing.Direct') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency1" no="frequency1">{{ $t('Pricing.Mon') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency2" no="frequency2">{{ $t('Pricing.Tue') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency3" no="frequency3">{{ $t('Pricing.Wed') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency4" no="frequency4">{{ $t('Pricing.Thu') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency5" no="frequency5">{{ $t('Pricing.Fri') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency6" no="frequency6">{{ $t('Pricing.Sat') }}</el-checkbox>
            <el-checkbox v-model="filter.frequency7" no="frequency7">{{ $t('Pricing.Sun') }}</el-checkbox>
            <el-form-item :label="$t('Pricing.volumeWeightRatio')" style="margin-left:20px;">
              <cargo-advance-select
                v-model="filter.volumeWeightRatio"
                no="volumeWeightRatio"
                :select-type="selectTypeNames.local_cache_SystemConstants$VOLUME_WEIGHT_RATIO"
                :custom-label="item=>item.name"
                :show-custom-label-in-option="true"
                :clearable="true"
                @parentCallBack="p=>{filter.volumeWeightRatio=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Pricing.DestinationAgent')">
              <div :title="destinationAgentTitle">
                <cargo-advance-select
                  no="destinationAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{designationAgent:true}"
                  :show-custom-label-in-option="true"
                  :multiple="true"
                  style="width: 100%"
                  :default-multiple-value="filter.destinationAgent"
                  @parentCallBack="p=>{filter.destinationAgent=p.value}"
                />
              </div>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput/index'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import DateUtils from '@/utils/dateUtils'
import StrUtils from '@/utils/StrUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'LclSearchBar',
  components: {
    CargoPopSelectInput,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: false }, // 是否显示录入人
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowContractNo: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    showCurrency: { type: Boolean, default: false },
    showLevel: { type: Boolean, default: false }, // 是否显示运价等级
    showSchedule: { type: Boolean, default: true },
    isQuery: { type: Boolean, default: false },
    configId: { type: String, required: true },
    filter: {
      type: Object, default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      tiers: [],
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      showDetail: false,
      priceNo: null,
      popSelectInputCols: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Price.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Price.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Price.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Price.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Price.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    localConfigId() {
      return this.configId + this.$store.getters.userId
    },
    destinationAgentTitle() {
      let destinationAgent = this.filter.destinationAgent
      if (Array.isArray(destinationAgent)) {
        destinationAgent = this.filter.destinationAgent.join(',')
      }
      return ColumnUtils.moreCompanyLabelFun(destinationAgent, 'englishName', 'cmpIdx')
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
      // this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.authedLevel = this.getAuthedLevel()
      const proxy = LocalStorageUtils.getConfiguration(this.localConfigId)
      if (proxy) {
        this.isShowingMoreSearchCondition = proxy.isAdvanced
        this.isAdvancedQuery = proxy.isAdvanced
        commonUtil.objCopy(proxy, this.filter)
      }
      this.$nextTick(() => {
        this.setPosition()
      })
    },
    setPosition() {
      const { hbDetail, hbDetail2, hbCarrier, hbSource, hbLevel, hbCurrency } = this.$refs
      if (!this.isQuery) {
        if (this.showLevel) {
          hbDetail2.$el.appendChild(hbLevel.$el)
        }
        return
      }
      hbDetail.$el.appendChild(hbCarrier.$el)
      hbDetail.$el.appendChild(hbSource.$el)
      if (this.showLevel) {
        hbDetail2.$el.appendChild(hbLevel.$el)
      }
      if (this.showCurrency) {
        hbDetail2.$el.appendChild(hbCurrency.$el)
      }
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = false
      this.proxy['tenantId'] = 0
      if (this.showPriceNo) {
        const priceNo = this.filter.priceNo ? this.filter.priceNo.trim() : ''
        if (!priceNo || priceNo.length === 0) {
          this.simQueryPlaceholder = ''
          this.$refs.keyword.focus()
          this.$message.warning(this.$t('Pricing.priceNoPrompt'))
          return
        }
        this.proxy['priceNo'] = priceNo
      } else {
        if (!this.filter.simPol) {
          this.$refs.simPol.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (!this.filter.simPod) {
          this.$refs.simPod.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        this.proxy['pol'] = this.filter.simPol
        this.proxy['pod'] = this.filter.simPod
        this.proxy['beginDate'] = DateUtils.formatStandardDate(new Date())
      }
      this.saveConfig()
      this.$emit('simSearchItemCallBack', this.proxy)
    },
    async toAdvancedQuery() {
      this.proxy = {}
      if (!this.proxy.hasOwnProperty('isLimited')) {
        this.proxy['isLimited'] = true
      }
      this.proxy['level'] = 1
      this.proxy['isAdvanced'] = true
      this.proxy['currency'] = this.filter.currency
      this.proxy['pol'] = this.filter.pol
      this.proxy['txtBookingAgent'] = this.filter.txtBookingAgent
      this.proxy['beginDate'] = this.filter.beginDate
      this.proxy['endDate'] = this.filter.endDate
      this.proxy['volumeWeightRatio'] = this.filter.volumeWeightRatio
      this.proxy['destinationAgent'] = this.filter.destinationAgent.join(',')
      if (this.isManageModule) {
        this.proxy['createDateFrom'] = this.filter.createDateFrom
        this.proxy['createDateTo'] = this.filter.createDateTo
      }
      this.proxy[this.rdoGroupOrg] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupOrg, 'pols')
      this.proxy[this.rdoGroupDes] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupDes, 'pods')
      const pols = await PriceUtils.getPortGroup(this.proxy.pol)
      if (pols && pols.length > 0) {
        this.proxy.pols = pols
        this.proxy.pol = ''
        delete this.proxy.pol
      }
      const pods = await PriceUtils.getPortGroup(this.proxy.pod)
      if (pods && pods.length > 0) {
        this.proxy.pods = pods
        this.proxy.pod = ''
        delete this.proxy.pod
      }
      if (this.proxy.hasOwnProperty('pol') && !this.proxy.pol) {
        delete this.proxy.pol
      }
      if (this.proxy.hasOwnProperty('pod') && !this.proxy.pod) {
        delete this.proxy.pod
      }
      if (this.proxy.hasOwnProperty('pols') && this.proxy.pols.length === 0) {
        delete this.proxy.pols
      }
      if (this.proxy.hasOwnProperty('pods') && this.proxy.pods.length === 0) {
        delete this.proxy.pods
      }
      if (this.rdoGroupOrg === 'pol' && pols && pols.length === 0) {
        delete this.proxy.pols
        delete this.proxy.col
        delete this.proxy.rol
      } else if (this.rdoGroupOrg === 'pol' && pols && pols.length > 0) {
        delete this.proxy.pol
        delete this.proxy.col
        delete this.proxy.rol
      } else if (this.rdoGroupOrg === 'pols') {
        delete this.proxy.pol
        delete this.proxy.col
        delete this.proxy.rol
      } else if (this.rdoGroupOrg === 'col') {
        delete this.proxy.pol
        delete this.proxy.pols
        delete this.proxy.rol
      } else if (this.rdoGroupOrg === 'rol') {
        delete this.proxy.pol
        delete this.proxy.pols
        delete this.proxy.col
      }
      if (this.rdoGroupDes === 'pod' && pods && pods.length === 0) {
        delete this.proxy.pods
        delete this.proxy.cod
        delete this.proxy.rod
      } else if (this.rdoGroupDes === 'pod' && pods && pods.length > 0) {
        delete this.proxy.pod
        delete this.proxy.cod
        delete this.proxy.rod
      } else if (this.rdoGroupDes === 'pods') {
        delete this.proxy.pod
        delete this.proxy.cod
        delete this.proxy.rod
      } else if (this.rdoGroupDes === 'cod') {
        delete this.proxy.pod
        delete this.proxy.pods
        delete this.proxy.rod
      } else if (this.rdoGroupDes === 'rod') {
        delete this.proxy.pod
        delete this.proxy.pods
        delete this.proxy.cod
      }
      if (this.showSchedule) {
        const FREQUENCYS = PriceUtils.FREQUENCYS
        const frequency = []
        for (const field of FREQUENCYS) {
          if (this.filter['frequency' + field]) {
            frequency.push('frequency' + field)
          }
        }
        frequency.join('/')
        this.proxy['frequencys'] = frequency
      }
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          this.proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          this.proxy['branchId'] = this.filter.branch
        }
      }
      if (this.filter.carrier.length === 0) {
        this.proxy['carriers'] = this.filter.carrier
      } else {
        this.proxy['carrierScac'] = this.filter.carrier
      }
      this.setBooleanValue('direct')
      if (this.isShowContractNo && StrUtils.isEmpty(this.filter.contractNo)) {
        this.proxy['contractNo'] = this.filter.contractNo
      }
      this.saveConfig()
      this.$emit('advSearchItemResetCallBack', this.proxy)
    },
    saveConfig() {
      const data = deepClone(this.filter)
      delete data['createDateFrom']
      delete data['createDateTo']
      delete data['beginDate']
      delete data['endDate']
      data['isAdvanced'] = this.isAdvancedQuery
      LocalStorageUtils.setConfiguration(this.localConfigId, data)
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PLDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PLDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PLDA_*_2'])) {
        return 2
      }
      return 99
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      // console.log('isShowingMoreSearchCondition', this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      const level = this.filter.level
      const currency = this.filter.currency
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = currency
      this.filter.level = level
      this.filter.saleState = -1
      this.$emit('reset')
    },
    onLevelChanged() {
      this.$emit('onLevelChanged', { level: this.filter.level })
    }
  }
}
</script>
<style scoped>
</style>
